/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Failed_Events_LabelInputs */



/**
* | output |
* | --- |
* | "Failed Events" |
*
* @param {Style_Guide_Failed_Events_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_failed_events_label = /** @type {((inputs?: Style_Guide_Failed_Events_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Failed_Events_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Evenements echoues")
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehlgeschlagene Ereignisse")
	if (locale === "it") return /** @type {LocalizedString} */ ("Eventi falliti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Неудачные события")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eventos fallidos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("失败事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("失敗したイベント")
	if (locale === "hi") return /** @type {LocalizedString} */ ("असफल घटनाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Eventos Falhos")
	return /** @type {LocalizedString} */ ("Failed Events")
});